export default "__VITE_ASSET__pox54rfx__"